<template>
  <div>
    <div>
      <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo mb-0">Documentos Solicitados</h3>
        <v-container fluid v-if="anexos.length > 0">
          <v-layout wrap align-center pa-1 white class="area-conteudo anexo">
            <v-flex xs12 sm12 md6 pa-2 v-for="(documento, index) in anexos" :key="index">
                  <span v-if="documento.descricao.length < 50">
                      <i class="far fa-file-alt mr-1" aria-hidden="true"></i>
                      {{ documento.descricao }}
                    </span>
              <span v-else>
                      <i class="far fa-file-alt mr-1" aria-hidden="true"></i>
                      <span :title="documento.descricao">{{ documento.descricao.slice(0, 50) }}...</span>
                    </span>
              <br>

              <div
                  v-if="['NAO_ANALISADO', 'AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao) && (documento.uri)">
                {{ documento.descricao.slice(0, 15) }}...

                <a @click="$emit('downloadAnexo', documento)"
                   target="_blank"
                   class="anexo__botao-link">
                  <i class="fa fa-download" aria-hidden="true"></i>
                </a>
                <a v-show="['AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao)" @click="$emit('removerDocumento', documento)"
                   class="anexo__botao-link remover">
                  <i class="fa fa-trash" aria-hidden="true"/>
                </a>
              </div>

                <compra-direta-upload-arquivo v-if="documentoAguardandoEnvioOuReenvio(documento) && !documentoJaApresentado(documento)"
                  :ref="'azFileUploadAnexoProposta' + index"
                  :multiple="false"
                  @error="tratarErroEnvioArquivo"
                  @uploadArquivo="tratarEventUploadArquivo($event, documento.documentoSolicitadoId)"
                  accept="application/pdf"
                  class="anexo__botao">
                <a @click="abrirSelecaoAnexo(index, documento.documentoSolicitadoId)" class="botao-anexo-proposta">
                  <i class="fas fa-paperclip" aria-hidden="true"></i>
                  Anexar
                </a>
              </compra-direta-upload-arquivo>

            </v-flex>

          </v-layout>
        </v-container>

      </v-flex>
    </div>
  </div>
</template>

<script>

import {actionTypes} from '@/core/constants'
import CompraDiretaUploadArquivo from '@/views/pages/commons/upload-arquivo/CompraDiretaUploadArquivo'
import alert from '@/views/mixins/alert'
import file from '@/views/mixins/file'
export default {
    name: 'Anexo',
    mixins: [alert, file],
    components:{CompraDiretaUploadArquivo},
    props: {
        anexos:{
            type: Array,
            default: () =>{
                return []
            }
        },
    },
    data() {
        return {
            repository: 'repo1:compradireta',
            anexoTemporario: {},
            pendingDocumentoSolicitadoId: null,
            urlAtual: null,
        }
    },
    methods: {
        abrirSelecaoAnexo(index, documentoSolicitadoId) {
            this.pendingDocumentoSolicitadoId = documentoSolicitadoId
            this.anexoTemporario = { documentoSolicitadoId }
            const refName = `azFileUploadAnexoProposta${index}`
            let uploader = this.$refs[refName]
            if (Array.isArray(uploader)) {
                uploader = uploader[0]
            }
            if (uploader && typeof uploader.openFileSelector === 'function') {
                uploader.openFileSelector()
            }
        },
        clearAnexoTemporarioState() {
            this.anexoTemporario = {}
            this.pendingDocumentoSolicitadoId = null
        },
        extensaoArquivoValida(nomeArquivo) {
            const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
            return extensao === '.pdf' || extensao === '.PDF'
        },
        documentoAguardandoEnvioOuReenvio(documento){
            return ['AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao)
        },
        documentoJaApresentado(documento){
            return documento.id && documento.uri
        },

        async tratarEventUploadArquivo(event, documentoSolicitadoId){
            if (!event || !event.filename || !event.formData) {
                this.mostrarNotificacaoErro('Falha ao ler o arquivo selecionado. Por favor, tente novamente.')
                this.resetUploadedFiles()
                this.clearAnexoTemporarioState()
                return
            }

            if (!this.extensaoArquivoValida(event.filename)) {
                this.mostrarNotificacaoErro('Extensão do arquivo inválida. Por favor, faça upload de um arquivo .pdf')
                this.resetUploadedFiles()
                this.clearAnexoTemporarioState()
                return
            }

            try {
                if (documentoSolicitadoId && !this.pendingDocumentoSolicitadoId) {
                    this.pendingDocumentoSolicitadoId = documentoSolicitadoId
                }
                if (!this.anexoTemporario || typeof this.anexoTemporario !== 'object') {
                    this.anexoTemporario = {}
                }
                if (documentoSolicitadoId && !this.anexoTemporario.documentoSolicitadoId) {
                    this.anexoTemporario.documentoSolicitadoId = documentoSolicitadoId
                }
                const { arquivo } = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, event.formData)
                this.adicionarAnexoCarregado(arquivo)
            } catch (e) {
                this.mostrarNotificacaoErro('Falha no envio do arquivo. Tente novamente.')
                this.clearAnexoTemporarioState()
            } finally {
                this.resetUploadedFiles()
            }
        },
        adicionarAnexoCarregado(arquivo) {
            if (arquivo) {
                if (!this.anexoTemporario || typeof this.anexoTemporario !== 'object') {
                    this.anexoTemporario = {}
                }
                if (!this.anexoTemporario.documentoSolicitadoId) {
                    this.anexoTemporario.documentoSolicitadoId = this.pendingDocumentoSolicitadoId
                }
                this.anexoTemporario.anexo = {
                    nome: arquivo.nome,
                    uri: arquivo.uri
                }
                this.$emit('adicionarAnexo', this.anexoTemporario)
                this.clearAnexoTemporarioState()
            }
            this.resetUploadedFiles()
        },
        tratarErroEnvioArquivo(err) {
            if (err && err.type === 'FILE_EXCEEDED_MAX_SIZE_LIMIT') {
                this.mostrarNotificacaoErro(`O arquivo selecionado deve ter no máximo ${this.$store.state.loki.file.maxSize}.`)
            } else {
                this.mostrarNotificacaoErro('Falha ao processar arquivo. Tente novamente.')
            }
            this.clearAnexoTemporarioState()
            this.resetUploadedFiles()
        }
    }
}
</script>

<style scoped lang="stylus">

a.botao-anexo-proposta
  background-color transparent !important
  border 1px solid var(--v-primary-base) !important
  color var(--v-primary-base) !important
  padding 5px 10px

  i
    color var(--v-primary-base) !important


  &:hover, &:active, &:focus
    background-color var(--v-primary-lighten1) !important
    border 1px solid var(--v-primary-lighten1) !important
    color: white !important

    i
      color: white !important


.anexo
  padding 10px 15px
  color #888

  .flex
    display flex
    justify-content space-between
    align-items center
    padding-right 20px
    margin-top 20px

  .flex:nth-child(even)
    padding-right 0

  .flex:nth-child(1), .flex:nth-child(2)
    margin-top 0

  p
    margin-bottom 0
    margin-right 10px

  &__botao-link
    background-color #fff
    color #888
    padding 5px 10px 5px 10px
    min-width 50px

    i
      color #777 !important
      font-size 13px
      top 0

    &:hover, &:active, &:focus
      background-color #e4e4e4
      border 0 !important

  .az-drop-file .center
    min-width 110px

.botao-enviar-anexos
  display table
  margin 0 auto
  padding-top 10px
  padding-bottom 10px

@media (max-width 991px)
  .anexo .flex
    padding-right 0
    margin-bottom 20px

.botao-assinado
  background-color #fff
  color #888
  padding 5px 10px 5px 5px
  min-width 50px

  i
    color #777 !important
    font-size 13px
    top 0

</style>
